import { BaseQueryFn } from '@reduxjs/toolkit/query'
import { AxiosError } from 'axios'
import { makeRequest, parseAndDecodeTransformResponse } from './axios'

interface AxiosBaseQueryArgs {
  url: string
  method: 'get' | 'post' | 'put' | 'delete' | 'patch'
  data?: any
  params?: any
  headers?: Record<string, string>
  requestId: string
}

const axiosBaseQuery =
  ({ baseUrl }: { baseUrl: string } = { baseUrl: '' }): BaseQueryFn<AxiosBaseQueryArgs, unknown, unknown> =>
  async ({ url, method, data, params, headers = {}, requestId }) => {
    try {
      // If the payload looks like JSON:API (data: { type: ... }), ensure required Content-Type is set
      const hasJsonApiBody = data && typeof data === 'object' && data.data && typeof data.data === 'object' && data.data.type
      const mergedHeaders: Record<string, string> = { Accept: 'application/json', ...headers }
      if (hasJsonApiBody && !Object.keys(mergedHeaders).some(h => h.toLowerCase() === 'content-type')) {
        mergedHeaders['Content-Type'] = 'application/vnd.api+json'
      }

      const result = await makeRequest({
        url: baseUrl + url,
        method,
        data,
        params,
        requestId,
        headers: mergedHeaders,
        transformResponse: parseAndDecodeTransformResponse,
      })
      return { data: result.data }
    } catch (axiosError) {
      const err = axiosError as AxiosError
      return {
        error: {
          status: err.response?.status || 'FETCH_ERROR',
          data: err.response?.data || err.message,
        },
      }
    }
  }

export default axiosBaseQuery
